// styles
import {
  TokenPurchaseEntryContainer,
  LeftContent,
  DateDisplay,
  ActionDisplay,
  TokenCountDisplay,
  TokenCount
} from './TokenPurchaseEntry.styles';

// assets
import tokenIcon from '../../../../assets/system/icons/pullvault-token.png';

export default function TokenPurchaseEntry({ content }) {
  const { details } = content;
  const { tier, prevCount, newCount } = details;
  const formattedTimestamp = content.timestamp?.toDate().toLocaleString();

  return (
    <TokenPurchaseEntryContainer className='widget-bg'>
      <LeftContent>
        <DateDisplay>{formattedTimestamp}</DateDisplay>
        <ActionDisplay>Purchased {tier.name} Tier ({tier.tokens} tokens)</ActionDisplay>
      </LeftContent>
      <TokenCountDisplay>
        <TokenCount style={{ opacity: 0.5 }}>
          <h4>{prevCount}</h4>
        </TokenCount>
        <span>&#x279F;</span>
        <TokenCount>
          <h4>{newCount}</h4>
          <img src={tokenIcon} alt="token icon" />
        </TokenCount>
      </TokenCountDisplay>
    </TokenPurchaseEntryContainer>
  );
} 